var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('picture',[(_vm.srcWebp)?_c('source',{attrs:{"srcset":_vm.srcWebp,"type":"image/webp"}}):_vm._e(),_vm._v(" "),_c('source',{attrs:{"srcset":_vm.src,"type":"image/jpeg"}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt,"loading":_vm.lazy ? 'lazy' : 'eager'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }